import { useState } from "react";
import {
  AlertDialog,
  AlertDialogClose,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogPopup,
  AlertDialogTitle,
  Button,
} from "@salestrak/ui";

interface ApiKeyRevokeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  apiKeyName: string;
  onConfirm: () => Promise<void>;
}

export function ApiKeyRevokeDialog({
  open,
  onOpenChange,
  apiKeyName,
  onConfirm,
}: ApiKeyRevokeDialogProps) {
  const [revoking, setRevoking] = useState(false);

  async function handleRevoke() {
    setRevoking(true);
    try {
      await onConfirm();
      onOpenChange(false);
    } finally {
      setRevoking(false);
    }
  }

  // One AlertDialog surface at every breakpoint.
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogPopup>
        <AlertDialogHeader>
          <AlertDialogTitle>Revoke &ldquo;{apiKeyName}&rdquo;?</AlertDialogTitle>
          <AlertDialogDescription>
            Once revoked, this personal API key will no longer grant access to
            SalesTrak data. This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogClose
            render={<Button variant="outline" />}
            disabled={revoking}
          >
            Cancel
          </AlertDialogClose>
          <Button
            variant="destructive"
            onClick={handleRevoke}
            disabled={revoking}
            loading={revoking}
          >
            Revoke key
          </Button>
        </AlertDialogFooter>
      </AlertDialogPopup>
    </AlertDialog>
  );
}
